import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpFromLineSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8 10.414.707-.707L11 7.413v9.088h2V7.414l2.293 2.293.707.707L17.414 9l-.707-.708-4-4a1 1 0 0 0-1.414 0l-4 4L6.586 9 8 10.414Zm-4.001 7.588h16.003v2H3.999v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpFromLineSharp);
export default Memo;
